import React from "react";
import Drawer from "@material-ui/core/Drawer";
import { useTheme } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import Hidden from "@material-ui/core/Hidden";
import DrawerContent from "../DrawerContent";
import { isHamburguerMenu}from '../../../utils/objectManipulations'
import useStyles from "./styles";

function Menu({ user, mobileOpen, menus, handleDrawerToggle, window }) {
  const classes = useStyles();
  const theme = useTheme();
  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <nav aria-label="mailbox folders">
      <Hidden smUp>
        <Drawer
          container={container}
          variant="temporary"
          anchor={theme.direction === "rtl" ? "right" : "left"}
          open={mobileOpen}
          onClose={handleDrawerToggle}
          classes={{
            paper: classes.drawerPaper,
          }}
          ModalProps={{
            keepMounted: true,
          }}
          >
          <DrawerContent
            menus={menus}
            user={user}
            handleDrawerToggle={handleDrawerToggle}
            />
        </Drawer>
      </Hidden>
       {isHamburguerMenu(user.mainGroup)
       ? (
       <Drawer
          container={container}
          variant="temporary"
          anchor={theme.direction === "rtl" ? "right" : "left"}
          open={mobileOpen}
          onClose={handleDrawerToggle}
          classes={{
            paper: classes.drawerPaper,
          }}
          ModalProps={{
            keepMounted: true,
          }}
        >
          <DrawerContent
            menus={menus}
            user={user}
            handleDrawerToggle={handleDrawerToggle}
          />
        </Drawer>)
: (   <Hidden smDown implementation="css">
        <Drawer
          classes={{
            paper: classes.drawerPaper,
          }}
          variant="permanent"
          open
        >
          <DrawerContent
            menus={menus}
            user={user}
            handleDrawerToggle={handleDrawerToggle}
          />
        </Drawer>
      </Hidden>)}
    </nav>
  );
}

Menu.propTypes = {
  user: PropTypes.object.isRequired,
  mobileOpen: PropTypes.bool.isRequired,
  menus: PropTypes.array,
};

export default Menu;
